<template>
    <div class="commentsContainer">
        <ul class="annotationsList">
            <li v-for="item in list" :key="item.id" class="annotationsGroup">
                <annotations-list-item
                    :item="item"
                    :data="data"
                    :corptype="corptype"
                    @delete="deleteAnnotation"
                    />
            </li>
        </ul>
    </div>
</template>

<script>
import AnnotationsListItem from "vcomponents/utilities/AnnotationsListItem.vue"
export default {
    components: {
        AnnotationsListItem
    },
    props: {
        list:{
            type: Array,
            required: false,
            default: () => []
        },
        data: {
            type: Object,
            required: false,
            default: () => {}
        },
        corptype: {
            type: String,
            required: false,
            default: ''
        },
    },
    methods: {
        deleteAnnotation(payload){
            this.$emit('delete', payload)
        }
    }
}
</script>